export const localPaths = {
    home: '',
};